import { z } from "zod";

/**
 * Per-user Ask Puntt email notification opt-in/out.
 * Mentions default on; other email toggles default off.
 */
export const askPunttNotificationPrefsSchema = z.object({
  emailMention: z.boolean().default(true),
  emailNewMessage: z.boolean().default(false),
  emailReviewComplete: z.boolean().default(false),
  emailArtifactReady: z.boolean().default(false),
  emailProjectActivity: z.boolean().default(false),
});

export type AskPunttNotificationPrefs = z.infer<
  typeof askPunttNotificationPrefsSchema
>;

export const defaultAskPunttNotificationPrefs: AskPunttNotificationPrefs =
  askPunttNotificationPrefsSchema.parse({});
